import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @atlaskit/design-system/no-nested-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { IconButton } from '@atlaskit/button/new';
import ConfirmIcon from '@atlaskit/icon/glyph/check';
import CancelIcon from '@atlaskit/icon/glyph/cross';
import { B400, N0, N20A, N30A, N50A, N60A } from '@atlaskit/theme/colors';
var buttonsContainerStyles = css({
  display: 'flex',
  position: 'absolute',
  flexShrink: 0,
  insetBlockStart: '100%',
  insetInlineEnd: 0,
  marginBlockStart: "var(--ds-space-075, 6px)"
});
var buttonWrapperBaseStyles = css({
  boxSizing: 'border-box',
  width: "var(--ds-space-400, 32px)",
  zIndex: 200,
  backgroundColor: "var(--ds-surface-overlay, ".concat(N0, ")"),
  borderRadius: "var(--ds-border-radius, 3px)",
  boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"),
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
  '&:last-child': {
    marginInlineStart: "var(--ds-space-050, 4px)"
  },
  '& > button': {
    backgroundColor: "var(--ds-surface-overlay, ".concat(N20A, ")")
  },
  '& > button:hover': {
    backgroundColor: "var(--ds-surface-overlay-hovered, ".concat(N30A, ")")
  },
  '& > button:active': {
    backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
    color: "var(--ds-text, ".concat(B400, ")")
  }
});
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Buttons__
 *
 * A buttons {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
var Buttons = function Buttons(_ref) {
  var confirmButtonLabel = _ref.confirmButtonLabel,
    cancelButtonLabel = _ref.cancelButtonLabel,
    onMouseDown = _ref.onMouseDown,
    onCancelClick = _ref.onCancelClick,
    testId = _ref.testId;
  return jsx("div", {
    css: buttonsContainerStyles
  }, jsx("div", {
    css: buttonWrapperBaseStyles,
    tabIndex: -1
  }, jsx(IconButton, {
    type: "submit",
    icon: function icon(iconProps) {
      return jsx(ConfirmIcon, _extends({}, iconProps, {
        size: "small"
      }));
    },
    onMouseDown: onMouseDown,
    label: confirmButtonLabel,
    testId: testId && "".concat(testId, "--confirm")
  })), jsx("div", {
    css: buttonWrapperBaseStyles,
    tabIndex: -1
  }, jsx(IconButton, {
    icon: function icon(iconProps) {
      return jsx(CancelIcon, _extends({}, iconProps, {
        size: "small"
      }));
    },
    label: cancelButtonLabel,
    onClick: onCancelClick,
    onMouseDown: onMouseDown,
    testId: testId && "".concat(testId, "--cancel")
  })));
};
export default Buttons;